// Copyright (c) 2023 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { ToastOptions } from "react-toastify"

export const validationSnackBarPayload = (message: string): SnackBar => ({
  message,
  messageType: "ERROR",
  displayContactInfo: false,
  options: {
    className: "snackbar--text-align-left",
  },
})
type MessageType = "SUCCESS" | "INFO" | "ERROR"
export type SnackBar = {
  message: string,
  messageType: MessageType,
  options?: ToastOptions,
  displayContactInfo?: boolean,
}
export const showSnackBar = createAction<SnackBar>("timelines/show-snackbar")
export const hideSnackBar = createAction<string>("timelines/hide-snackbar")
export const snackBarDone = createAction("timelines/show-snackbar-done")
